const isMobileDevice = navigator.userAgent.toLowerCase().match(/mobile/i) || 
    navigator.userAgent.toLowerCase().match(/tablet/i) ||
    navigator.userAgent.toLowerCase().match(/android/i) ||
    navigator.userAgent.toLowerCase().match(/iphone/i) ||
    navigator.userAgent.toLowerCase().match(/ipad/i);